import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import pic12 from "../assets/email.png";
import pic13 from "../assets/telegram.webp";
import pic2 from "../assets/linkedin.png";
import pic3 from "../assets/github.png";

const Contact = () => {
  const { t } = useTranslation();

  const contactItems = [
    {
      id: "email",
      icon: pic12,
      alt: "Email icon",
      label: "Mr.Akb404@gmail.com",
      href: "mailto:mr.akb404@gmail.com",
      target: "_self",
    },
    {
      id: "telegram",
      icon: pic13,
      alt: "Telegram icon",
      label: "@akbarshohi",
      href: "https://t.me/akbarshohi",
      target: "_blank",
    },
    {
      id: "linkedin",
      icon: pic2,
      alt: "LinkedIn icon",
      label: "LinkedIn",
      href: "https://www.linkedin.com/in/akbarshoh-ismatov-4179b52a8/",
      target: "_blank",
    },
    {
      id: "github",
      icon: pic3,
      alt: "GitHub icon",
      label: "GitHub",
      href: "https://github.com/Akbarshoh404",
      target: "_blank",
    },
  ];

  return (
    <section id="contact">
      <motion.div
        initial={{ opacity: 0, y: 25 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
      >
        <p className="section__text__p1">{t("contact_subtitle")}</p>
        <h1 className="title">{t("contact_title")}</h1>
      </motion.div>

      <motion.div 
        className="contact-info-upper-container"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, delay: 0.15 }}
      >
        {contactItems.map((item) => (
          <motion.a
            key={item.id}
            href={item.href}
            target={item.target}
            rel="noreferrer"
            className="contact-info-container clickable"
            whileHover={{ y: -4, scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            transition={{ type: "spring", stiffness: 400, damping: 25 }}
          >
            <img
              src={item.icon}
              alt={item.alt}
              className="icon contact-icon"
            />
            <span className="contact-link-text">{item.label}</span>
          </motion.a>
        ))}
      </motion.div>
    </section>
  );
};

export default Contact;
